export default "__VITE_ASSET__BNOVYyvp__"